export default "assets/images/icons/arrow-c09868c1.svg";